import { getTenantByHost, tenants } from '@pelicargo/tenants';
import { Show } from '@pelicargo/ui';
import { PropsWithChildren } from 'react';

// We're always there so we can base the type off of us
type Features = keyof (typeof tenants)['pelicargo']['admin']['features'];

export const FeatureAllowed = ({ feature, children }: PropsWithChildren<{ feature: Features }>) => {
  const allowed = getTenantByHost()['admin']['features'][feature];
  return <Show if={allowed}>{children}</Show>;
};
